var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"message-notice"},[(_vm.message)?_c('b-alert',{staticClass:"notice-alert",attrs:{"dismissible":"","variant":_vm.notice.type},domProps:{"innerHTML":_vm._s(_vm.message)},model:{value:(_vm.isShowNotice),callback:function ($$v) {_vm.isShowNotice=$$v},expression:"isShowNotice"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }